// extracted by mini-css-extract-plugin
module.exports = {"price":"price__2770c"};